export const STORAGE_KEY: string = 'photo-bank'

// Served by the photo-previews route, which redirects the photo's owner to a presigned URL of the preview
export const PHOTO_PREVIEWS_PATH = '/photo-previews'

export const PHOTO_PREVIEW_SIZES = { MIN: 'min', HIGH: 'high' } as const

// Marks a preview link loaded by a canvas or texture, which the route redirects to its own CORS-only URL
export const PHOTO_PREVIEW_CANVAS_PARAM = 'canvas'

export const UPLOAD_SRC = {
  PHOTO_WALL: 'photo-wall',
  TILE_DESIGNER: 'tile-designer',
  PHOTO_BOOK: 'photo-book',
  ORDER_MANAGEMENT: 'order-management',
  AI_SOURCE: 'ai-source',
  AI_RESULT: 'ai-result',
} as const
